import React, { FC, ReactElement, useMemo } from 'react';
import { Container, Header } from './TopAndBottomTopics.styles';
import PageSection from '../../HOC/PageSection/PageSection';
import { useFilters } from '../../hooks/useFilters';
import { IStrengthsAndWeaknessesData, ITopAndBottomTopics } from '../../services/reports';
import Statistics from '../Statistics/Statistics';
import StrengthsAndWeaknesses from '../StrengthsAndWeaknesses/StrengthsAndWeaknesses';

interface ITopAndBottomTopicsProps {
  sectionTitle: ReactElement;
  strengthsAndWeaknesses?: IStrengthsAndWeaknessesData;
  topAndBottomTopics?: ITopAndBottomTopics | null;
  isExecutiveReport: boolean;
}

const TopAndBottomTopics: FC<ITopAndBottomTopicsProps> = ({
  sectionTitle,
  strengthsAndWeaknesses,
  topAndBottomTopics,
}) => {
  const { currentFilters } = useFilters();

  const getTopicsFilters = useMemo(() => {
    const topics = currentFilters?.topAndBottomTopics;

    if (topics) {
      // @ts-expect-error query-string types a value as string | string[]
      const filters = JSON.parse(topics);

      return {
        mode: filters?.mode || 'totals',
      };
    }
  }, [currentFilters?.topAndBottomTopics]);

  const activeMode = getTopicsFilters?.mode || 'totals';

  const isTotalsTabActive = useMemo(() => activeMode === 'totals', [activeMode]);

  return (
    <>
      <Header>{sectionTitle}</Header>
      <PageSection>
        <Container>
          {isTotalsTabActive
            ? topAndBottomTopics && <Statistics data={topAndBottomTopics} />
            : strengthsAndWeaknesses && <StrengthsAndWeaknesses data={strengthsAndWeaknesses} />}
        </Container>
      </PageSection>
    </>
  );
};

export default TopAndBottomTopics;
